import { css } from 'styled-components';

const layoutStyle = css`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export default layoutStyle;
